<template>
  <div class="flex flex-col space-y-4 lg:space-y-6 px-4 sm:px-0">
    <!--    <h1 class="text-xl font-medium">-->
    <!--      {{ $t(`site.library.status.${status}.title`) }}-->
    <!--    </h1>-->
    <NamiLoading v-if="pending" />
    <p v-else-if="data?.total === 0" class="text-center">
      {{ $t(`site.library.status.${status}.no_titles`) }}
    </p>
    <div
      v-else-if="data"
      class="grid responsive-gap grid-cols-3 md:grid-cols-4 xl:grid-cols-6"
    >
      <TitleFollowCard
        v-for="follow in data.titles"
        :title-entity="follow.title!"
        :follows-entity="follow.follow"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ALL_CONTENT,
  ALL_READING_STATUSES,
  type ContentRating,
  isTitle,
  Title,
  type TitleReadingStatus,
} from "~/src/api";

const nuxtApp = useNuxtApp();
const settingsStore = nuxtApp.$settings();
const route = useRoute();
const { limit, offset } = usePagination();

const tryConvertToReadingStatus = (
  status: string,
): TitleReadingStatus | false => {
  if (status === "planned") return "plan_to_read";
  if (status === "hold") return "on_hold";
  if (!ALL_READING_STATUSES.includes(status as TitleReadingStatus))
    return false;
  return status as TitleReadingStatus;
};

const status = tryConvertToReadingStatus(route.params.status as string);

const { pending, data } = useAsyncData(
  `library-status-${route.params.status as string}`,
  async () => {
    await settingsStore?.waitForInitialization();

    if (!status) return;
    const contentRating: ContentRating[] = settingsStore!.settings.platform
      .matureContentEnabled
      ? ALL_CONTENT
      : ["safe"];
    const token = await getTokenOrThrow();

    const followedTitles = await Title.getUserFollows(
      {
        readingStatuses: [status],
        contentRating,
      },
      token,
    );

    const paginatedIds = followedTitles.data
      .map((follow) => follow.relationships.find(isTitle)?.id)
      .filter(onlyTruthys);

    const results = await Title.search({
      includes: ["cover_art"],
      ids: paginatedIds,
      contentRating,
      // Limit 0 because for a 0-length array the URL is seen as if it's not passed at all, fetching arbitrary titles
      limit: paginatedIds.length === 0 ? 0 : undefined,
    });

    return {
      titles: followedTitles.data
        .map((followEntity) => ({
          title: results.data.find(
            (title) =>
              title.id === followEntity.relationships.find(isTitle)?.id,
          ),
          follow: followEntity,
        }))
        .filter((g) => onlyTruthys(g.title)),
      ...followedTitles.meta,
    };
  },
  { server: false, watch: [limit, offset] },
);
</script>

<style scoped lang="postcss"></style>
